import { PopupType } from '@nx-frontend/shared/types';
import { OpenModalFn } from '@nx-frontend/shared/types';

export function showCopyAccessDeniedPopup(openModal: OpenModalFn) {
  openModal({
    title: 'Access denied while moving/copying item',
    content: PopupType.DIALOG,
    closeButtonSize: 18,
    payload: {
      payloadType: PopupType.DIALOG,
      text: 'You do not have enough permissions to move/copy to this workspace. Contact the workspace owner to get the necessary permissions.',
      buttons: [
        {
          text: 'OK',
          main: true,
        },
      ],
    },
  });
}
